import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "../../utils/ui-components.js";

@customElement("api-docs-rate-limiting")
export class ApiDocsRateLimiting extends BaseElement {
    connectedCallback() {
        super.connectedCallback();
        this.style.display = "block";
    }

    render() {
        return html`
            <section class="space-y-4">
                <h2 class="text-2xl font-bold">Rate Limiting</h2>
                <p>The API enforces a sliding-window rate limit of <strong>60 requests per minute</strong> per account.</p>

                <h3 class="text-lg font-semibold">Response Headers</h3>
                <p>Every response includes rate-limit headers so you can track your usage:</p>

                <div class="overflow-x-auto">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Header</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><code class="badge badge-ghost">X-RateLimit-Limit</code></td>
                                <td>Maximum requests allowed per window (60)</td>
                            </tr>
                            <tr>
                                <td><code class="badge badge-ghost">X-RateLimit-Remaining</code></td>
                                <td>Requests remaining in the current window</td>
                            </tr>
                            <tr>
                                <td><code class="badge badge-ghost">X-RateLimit-Reset</code></td>
                                <td>Seconds until the oldest request in the window expires</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="text-lg font-semibold">Exceeding the Limit</h3>
                <p>
                    When you exceed the rate limit, the API returns <code class="badge badge-ghost">429 Too Many Requests</code>. Wait for the number
                    of seconds in the <code class="badge badge-ghost">X-RateLimit-Reset</code> header before retrying.
                </p>

                <api-docs-code-block
                    .code=${`{
  "error": "Too many requests. Please try again later."
}`}
                ></api-docs-code-block>

                <div class="alert alert-info">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                    </svg>
                    <span>Tip: implement exponential backoff in your integration — wait 1s, then 2s, then 4s on repeated 429 responses.</span>
                </div>
            </section>
        `;
    }
}
